import React from "react";
import { Scrollbar } from "react-scrollbars-custom";
import Dropdown from "components/Dropdown";
import Tag from "components/Tag";

import { translateSize } from "utils/product";
import { COLOR_CATEGORIES } from "constants/collection";
import { SIZE_LOCALES } from "constants/product";
import {
  AccordionItem,
  AccordionLabel,
  AccordionContent,
  AccordionContentInner,
  DropdownWrapper,
} from "./Menu.styles";

export const OptionGroupMenu = (props) => {
  if (!props.optionGroups.length) {
    return null;
  }

  return props.optionGroups.map((group, i) => {
    const open = props.openItem === group.name;
    const name = group.name.replace("'", "’");
    
    return (
      <AccordionItem key={i}>
        <AccordionLabel onClick={() => props.onItemClick(group.name)}>
          <span>{name.replace(props.title, "")}</span>
          <i className={`icon-chevron-${open ? "up" : "down"}`}></i>
        </AccordionLabel>
        <AccordionContent>
          {open && (
            <AccordionContentInner>
              {group.name.match(/size/i) && (
                <DropdownWrapper>
                  <Dropdown
                    isSearchable={false}
                    onChange={props.onSizeLocaleChange}
                    options={SIZE_LOCALES}
                    value={props.sizeLocale}
                  />
                </DropdownWrapper>
              )}
              <Scrollbar style={{ height: props.scrollHeight }}>
                <div ref={props.collectionScrollContentRef}>
                  {group.name === "Color"
                    ? Object.keys(COLOR_CATEGORIES).map((value, index) => {
                      const selectedValue = `variant:${group.name}:${value}`;
                      const selectedValues = Object.values(
                        COLOR_CATEGORIES[value].map(
                          (color) => `variant:${group.name}:${color}`
                        )
                      );

                      return (
                        <Tag
                          key={index}
                          text={translateSize(
                            value,
                            props.sizeLocale.value,
                            group.productType
                          )}
                          active={props.filters.includes(selectedValue)}
                          width="50%"
                          onClick={() =>
                            selectedValues.map((value) =>
                              props.toggleFilter(value)
                            )
                          }
                        />
                      );
                    })
                    : group.values.map((values, i) => {
                      const selectedValue = `variant:${group.name}:${values}`;
                      return (
                        <Tag
                          key={i}
                          text={translateSize(
                            values,
                            props.sizeLocale.value,
                            group.productType
                          )}
                          active={props.filters.includes(selectedValue)}
                          width={group.name.match(/size/i) ? "33.3%" : "100%"}
                          onClick={() => props.toggleFilter(selectedValue)}
                        />
                      );
                    })}
                </div>
              </Scrollbar>
            </AccordionContentInner>
          )}
        </AccordionContent>
      </AccordionItem>
    );
  });
};